module.exports = __webpack_public_path__ + "static/media/icon_workshop.06abe59e.svg";